import React, { useState } from "react"
import Select, { components } from "react-select"
import Icon from "../../../../blocks/icon/Icon"

function LocationSearchField({
  locationFilter,
  setLocationFilter,
  setShowLocationField,
}) {
  const { DropdownIndicator } = components;

  const options = [
    { value: "Auvergne_Rhone_Alpes", label: "Auvergne-Rhone-Alpes" },
    { value: "Bourgogne_Franche_Comte", label: "Bourgogne-Franche-Comte" },
    { value: "Bretagne", label: "Bretagne" },
    { value: "Centre_Val_de_Loire", label: "Centre-Val-de-Loire" },
    { value: "Corse", label: "Corse" },
    { value: "Grand_Est", label: "Grand-Est" },
    { value: "Hauts_de_France", label: "Hauts-de-France" },
    { value: "Ile_de_France", label: "Ile-de-France" },
    { value: "Normandie", label: "Normandie" },
    { value: "Nouvelle_Aquitaine", label: "Nouvelle-Aquitaine" },
    { value: "Occitanie", label: "Occitanie" },
    { value: "Pays_de_la_Loire", label: "Pays-de-la-Loire" },
    {
      value: "Provence_Alpes_Cote_d_Azur",
      label: "Provence-Alpes-Côte d’Azur",
    },
  ]

  const customStyles = {
    control: (baseStyles, state) => ({
      display: "flex",
      background: "var(--input-background-color)",
      borderRadius: "var(--border-radius)",
      cursor: "pointer",
    }),
    valueContainer: (provided, state) => ({
      // fontSize: '1px',
      //color: 'white',
      textOverflow: "ellipsis",
      //whiteSpace: "nowrap",
      overflow: "hidden",
      display: "flex",
      width: "100%",
      paddingBlock: "16px",
      paddingLeft: "24px",
    }),
    indicatorContainer: (provided, state) => ({
      ...provided,
      paddingInline: "24px",
    }),
  }

  const classNames = {
    container: (state) => "form-control",
  }

  const dropdownIndicator = (props) => {
    return (
      <DropdownIndicator
        className="pin-3"
        {...props}
      >
        <Icon
          icon="geo"
          color="var(--gris)"
          width="22"
          height="22"
        />
      </DropdownIndicator>
    )
  }
  

  const multiValueContainer = ({ selectProps, data }) => {
    const label = data.label
    const allSelected = selectProps.value
    const index = allSelected.findIndex((selected) => selected.label === label)
    const isLastSelected = index === allSelected.length - 1
    const labelSuffix = isLastSelected ? `` : ", "
    const val = "Régions..." //'Régions ...' //`${label}${labelSuffix}`
    return index === 0 ? "Régions..." : ""
  }

  const [menuIsOpen, setMenuIsOpen] = useState(false)

  const handleMenuClose = () => {
    if (setShowLocationField) {
      setMenuIsOpen(false)
      setShowLocationField(false)
    }
  }

  return (
    <Select
      classNames={classNames}
      isMulti={true}
      options={options}
      closeMenuOnSelect={false}
      value={locationFilter}
      onChange={setLocationFilter}
      placeholder={"Régions..."}
      hideSelectedOptions={false}
      components={{
        MultiValueContainer: multiValueContainer,
        DropdownIndicator: dropdownIndicator,
        IndicatorSeparator: () => null,
        // Option: CustomOption,
      }}
      styles={customStyles}
      isSearchable={false}
      onMenuOpen={() => setMenuIsOpen(true)}
      onMenuClose={handleMenuClose}
    />
  )
}

export default LocationSearchField
